export const cooperativeEndpoint = 'cooperative';

export interface Image {
  filename: string;
}
export interface Cooperative {
  _id: string;
  name: string;
  backCard: Image;
  frontCard: Image;
  helpImage: Image;
  codeMaxLenght: number;
  pointsFor12: string;
  pointsFor24: string;
  librettoAllowed: boolean;
  summaryCoopAlleanza:string;
  ruleBookUnicaCoop:string;
  unicaCoopPromoMessage: string;

}



// WEBPACK FOOTER //
// ./src/app/models/cooperatives.ts